module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_landscape-7087df5ffe7b0b046098061e48fe7dd6.png";